import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Dispatch, store } from '../../../utils/types';
import { queryWithCurrentQueryDetails } from '../../../actions/query';
import { useHistory } from 'react-router-dom';

const Search = ({ values, queryWithCurrentQueryDetailsAction }: any) => {
  const history = useHistory();

  const onSubmit = () => {
    queryWithCurrentQueryDetailsAction(history);
  };

  return (
    <div id="query-search-button" className="flex flex-row-reverse mt-5">
      <button
        disabled={isEmpty(values.search)}
        className="px-4 py-1 text-base font-medium button-search unselectable"
        onClick={onSubmit}
      >
        Visualize
      </button>
    </div>
  );
};

const mapStateToProps = (state: store) => ({
  values: state.query.currentQueryDetails,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  queryWithCurrentQueryDetailsAction: (history: any) =>
    dispatch(queryWithCurrentQueryDetails(history)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);
